import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./promotion-theme.css";
import { PromotionSidebar } from "./components/PromotionSidebar";
import { PromotionTopBar } from "./components/PromotionTopBar";

const THEME_KEY = "growthai_promo_theme";

export default function PromotionLayout() {
  const location = useLocation();
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || "dark");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <div
      className={`promo-scope ${theme === "light" ? "promo-light" : ""} flex min-h-screen`}
      data-testid="promotion-center"
    >
      <PromotionSidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <PromotionTopBar theme={theme} onToggleTheme={toggleTheme} onOpenMenu={() => setMobileOpen(true)} />
        <main className="flex-1 p-6 md:p-10" data-testid="promo-content">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="mx-auto max-w-[1400px]"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
